import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { DeliverySlotsResponse } from '~/api/ETA';

import SlotItem from '../SlotItem';

import styles from './SlotList.module.scss';

interface SlotListProps {
  selectedDate?: string;
  selectedSlotId?: string;
  deliverySlots: DeliverySlotsResponse;
  onSlotSelect: (slotId: string, hasAvailableProducts?: boolean) => void;
  priceWithoutDelivery: number;
}

const SlotList: FC<SlotListProps> = ({
  selectedDate,
  selectedSlotId,
  deliverySlots,
  onSlotSelect,
  priceWithoutDelivery,
}) => {
  return (
    <ul className={styles.slotList}>
      {selectedDate &&
        deliverySlots[selectedDate]?.map((slot) => {
          return (
            <SlotItem
              key={slot.schedule_slot_id}
              slot={slot}
              isSelected={slot.schedule_slot_id === selectedSlotId}
              onSelect={onSlotSelect}
              priceWithoutDelivery={priceWithoutDelivery}
            />
          );
        })}
    </ul>
  );
};

export default observer(SlotList);
